import React, {useEffect, useState} from 'react';
import useMiscPageData from '../hooks/useMiscPageData';
import TakisHero from "../components/TakisHero"
import TakisFreeText from '../components/TakisFreeText';
import TakisHeroSkeleton from "../components/Skeletons/TakisHeroSkeleton";
import TakisFreeTextSkeleton from "../components/Skeletons/TakisFreeTextSkeleton";

const Misc = ({pagePath}) => {
  const [miscPageData, setMiscPageData] = useState('');
  const { error, isLoading, miscPageQueryData } = useMiscPageData(pagePath);

  useEffect(() => {
    if (miscPageQueryData) {
      setMiscPageData(miscPageQueryData);
    }
  }, [miscPageQueryData]);

  if (isLoading || error || !miscPageData) {
    return (
      <>
        <TakisHeroSkeleton/>
        <TakisFreeTextSkeleton/>
      </>
    );
  }

  return (
    <>
      <TakisHero data={miscPageData.hero}/>
      <TakisFreeText
        title={miscPageData.freeText.title}
        isSectionTitle={true}
        paragraphsFirstColumn={miscPageData.freeText.paragraphsFirstColumn}
        paragraphsSecondColumn={miscPageData.freeText.paragraphsSecondColumn}
        ctas={miscPageData.freeText.ctas}
      />
    </>
  );
};

export default Misc;
